import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterIntegrationApi } from '@assetaccountant/api/services/register-integration.api';
import { TypedActivatedRoute } from '@assetaccountant/core/utils/route-utils';
import { OidcStateParams } from '@assetaccountant/integrations/models/oidc-state-params';

@Component({
  selector: 'app-sagev2-connect-company',
  templateUrl: './sagev2-connect-company.component.html',
  styleUrls: ['./sagev2-connect-company.component.scss'],
  standalone: false,
})
export class SageV2ConnectCompanyComponent implements OnInit {
  returnRoute: string;
  code: string;

  get title() {
    return { pageTitle: 'Sage Intacct Integration' };
  }

  constructor(
    private router: Router,
    @Inject(ActivatedRoute)
    private route: TypedActivatedRoute<{}, {}, { code: string; state: string }>,
    private integrationsApi: RegisterIntegrationApi,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const localState = localStorage.getItem('aa-oidc-state');

      if (params && localState === params.state) {
        const stateParams: OidcStateParams = JSON.parse(atob(params.state));

        this.returnRoute = stateParams.returnRoute;
        this.code = params.code;

        const redirectMatch = /\bregisters\/(\d+)/.exec(stateParams.returnRoute);
        const registerId = (redirectMatch && redirectMatch[1]) || '';

        if (registerId) {
          this.integrationsApi
            .connectSageIntacctV2({
              authorizationCode: params.code,
              registerId: +registerId,
            })
            .subscribe({
              next: () => {
                location.href = stateParams.returnRoute;
              },
              error: () => {
                location.href = stateParams.returnRoute;
              },
            });
        } else {
          this.router.navigateByUrl(this.returnRoute);
        }
      } else {
        this.router.navigate(['/organisations/-']);
      }
    });
  }
}
